<template>
    <div class="detail-row project-detail-contract-tab">
        <div class="detail-block">
            <div class="project-contract-list">
                <el-table class="ah-el-data-table" :data="members" key="contract" empty-text="無資料" style="margin-bottom: 40px;">
                    <el-table-column type="index" width="45" label="#"></el-table-column>
                    <el-table-column prop="employeeName" width="180" label="姓名"></el-table-column>
                    <el-table-column prop="eml" label="帳號"></el-table-column>
                   <el-table-column prop="paymentRequest" label="申請請款單" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.paymentRequest"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="paymentBudgetChart" label="顯示請款預算" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.paymentBudgetChart"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="invoice" label="申請發票" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.invoice"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="laborForm" label="申請勞報單" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.laborForm"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="viewProject" label="檢視專案內容" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.viewProject"></i>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uploadDocument" label="上傳文件" width="100" align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-check" v-if="scope.row.uploadDocument"></i>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        members: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
    },
    data() {
        return {
            tempMembers: [
                {
                    sno: 1,
                    nam: '陳彥霖',
                    eml: 'grass@charismatw.com',
                    authPayment: true,
                    authInvoice: true,
                    authServiceFee: false,
                    authDetail: false,
                    authDocs: false,
                },
                {
                    sno: 1,
                    nam: '鄭禹舜',
                    eml: 'caffine@charismatw.com',
                    authPayment: false,
                    authInvoice: true,
                    authServiceFee: true,
                    authDetail: false,
                    authDocs: true,
                },
            ],
        };
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>

</style>
